import dataProvider from '@/api'
import axios from 'axios'
import cookies from '@/services/cookies'

export default {
  /**
   * @description Адреса клиента
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/ClientsAddresses
   *
   * @return {object}
   */
  getClientAddress () {
    return dataProvider.get('/clients/addresses')
  },

  /**
   * @description Добавление или редактирование адреса клиента
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/EditClientsAddresses
   *
   * @param {object} payload - при редактировании
   * @param {string} payload.clientAddressId_H
   * @param {object} payload.addressInfo
   * @param {number} payload.addressInfo.city_id
   * @param {string} payload.addressInfo.street
   * @param {string} payload.addressInfo.house
   * @param {number} payload.addressInfo.longitude
   * @param {number} payload.addressInfo.latitude
   * @param {string} payload.addressInfo.city
   * @param {string} payload.addressInfo.areaWithType
   * @param {string} payload.addressInfo.settlementWithType
   * @param {string} payload.addressInfo.block
   * @param {string} payload.addressInfo.block_type
   * @param {string} payload.addressInfo.flat
   * @param {number} payload.addressInfo.floor
   * @param {string} payload.addressInfo.entrance
   *
   * @return {object}
   */
  postClientAddress (payload = {}) {
    return dataProvider.post('/clients/addresses', payload)
  },

  /**
   * @description Удаляет адрес клиента
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/DeleteClientsAddress
   *
   * @param payload
   * @return {object}
   */
  deleteClientAddress (payload = {}) {
    return dataProvider.delete('/clients/addresses', payload)
  },

  /**
   * @description Редактирование полей адреса не влияющих на адрес дома
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/EditClientsAddressFields
   *
   * @param {object} payload
   * @param {string} payload.clientAddressId_H
   * @param {number} payload.floor
   * @param {number} payload.flat
   * @param {string} payload.entrance
   * @param {string} payload.comment
   *
   * @return {object}
   */
  postClientAddressFields (payload = {}) {
    return dataProvider.post('/clients/addresses/fields', payload)
  },

  /**
   * @description Получение профиля клиента и настроек
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/ClientsProfile
   *
   * @param payload
   * @param payload.brandId_H - required - Хэшированный id бренда
   * @return {object}
   */
  getClientProfile (payload = {}) {
    return dataProvider.get('/clients/profile', payload)
  },

  /**
   * @description Получение кошелька клиента
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/ClientsWallet
   *
   * @return {object}
   */
  getClientWallet () {
    return dataProvider.get('/clients/wallet')
  },

  /**
   * @description Включение автосписания бонусов (для заказов или продлений)
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/ClientsBonusSettingEnable
   *
   * @param {object} payload
   * @param {string} payload.type - required - order || longation
   *
   * @return {object}
   */
  postClientBonusSettings (payload = {}) {
    return dataProvider.post('/clients/bonus-settings', payload)
  },

  /**
   * @description Изменить сводные данные по клиенту
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/ClientsBonusSettingDisable
   *
   * @param {object} payload
   * @param {string} payload.email - почта клиента
   *
   * @return {object}
   */
  postClientProfile (payload) {
    return dataProvider.put('/clients/profile', payload)
  },

  /**
   * @description Обновляет информацию в профиле клиента
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/UpdateClientDetails
   *
   * @param {object} payload
   * @param {number} payload.height
   * @param {number} payload.weight
   * @param {number} payload.menuTypeGroupId
   * @param {string} payload.lifestyleId_H
   * @param {number} payload.purposeWeight
   * @param {boolean} payload.eatsSomethingElse
   * @param {string} payload.gender
   * @param {date} payload.birthday
   *
   * @return {object}
   */
  updateClientDetails (payload = {}) {
    return dataProvider.post('/client-details/update-details', payload)
  },

  /**
   * @description Получает возможные типы физической активности
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/GetLifestylesClientDetails
   *
   * @return {object}
   */
  getLifestyles () {
    return dataProvider.get('/client-details/lifestyles')
  },
  /**
   * @param payload
   * @param payload.phone
   */
  sendAppLink (payload) {
    return dataProvider.post('/sms/mobile-app', payload)
  },
  /**
   * @param {Object} payload - данные для ИМТ
   * @description расчет Параметров ИМТ
   */
  calculateImt (payload) {
    return dataProvider.post('/client-details/calculate', payload)
  },
  /**
   * @param payload.tourName название обучалки
   * @description Создание записи в профилое о просмотре обучения
   */
  setClientTour (payload) {
    return dataProvider.post('/client-tours', payload)
  },

  /**
   * @param payload
   * @param payload.burnId_H
   */
  longateBonuses (payload) {
    return dataProvider.post('/finance/longate-bonuses', payload)
  },

  getStandardJson (cr = Math.random().toString()) {
    return axios.get(`${cookies.get('STORAGE_URL')}/menus/growfood/standard.json?cr=` + cr)
  },
}
